import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import client from './rest/AdminClient';

var api1 = 'api/1/';

const ajax = {
    get: function (url) {
        return client({
            method: 'GET',
            path: url,
        });
    },

    method: function (method, url, data) {
        return client({
            method: method.toUpperCase(),
            path: url,
            entity: JSON.stringify(data),
        });
    },
};

export function getAccessorialRates(contractId) {
    return ajax.get(`${api1}contracts/${contractId}/accessorials`)
        .then(function (res) {
            AdminServerActionCreators.receiveAccessorialRates(res.entity.accessorialRates);
            return res;
        })
        .catch(function (err) {
            console.log(err.stack || err);
        });
}

export function getAccessorialRate(id) {
    return ajax.get(api1 + 'accessorialRates/' + id)
        .then(function (res) {
            AdminServerActionCreators.receiveAccessorialRate(res.entity);
            return res;
        })
        .catch(function (err) {
            console.log(err.stack || err);
        });
}

export function addAccessorialRate(accessorialRate) {
    return ajax.method('post', api1 + 'accessorialRates', accessorialRate)
        .then(function (res) {
            AdminServerActionCreators.receiveAddAccessorialRateSuccess(res.entity);
            return res;
        })
        .catch(function (err) {
            console.log(err.stack || err);
        });
}

export function updateAccessorialRate(accessorialRate) {
    var entity = { accessorialRate: accessorialRate };
    return ajax.method('patch', api1 + 'accessorialRates/' + accessorialRate._id, entity)
        .then(function (res) {
            AdminServerActionCreators.receiveUpdateAccessorialRateSuccess(res.entity);
            return res;
        })
        .catch(function (err) {
            console.log(err.stack || err);
            AdminServerActionCreators.receiveUpdateAccessorialRateFail(err);
        });
}

export function removeAccessorialRate(accessorialRate, password) {
    var path = api1 + 'accessorialRates/' + accessorialRate._id;
    var entity = JSON.stringify({ password: '111111' });
    client({ method: 'DELETE', path: path, entity: entity })
        .then(function (res) {
            AdminServerActionCreators.receiveRemoveAccessorialRateSuccess(accessorialRate);
        })
        .catch(function (err) {
            console.log(err.stack || err);
            AdminServerActionCreators.receiveRemoveAccessorialRateFail(err);
        });
}
